module.exports = __webpack_public_path__ + "img/wutao.8752f3f7.png";